import { render, staticRenderFns } from "./IngredientProductionModal.vue?vue&type=template&id=5b404b9a&scoped=true"
import script from "./IngredientProductionModal.vue?vue&type=script&lang=js"
export * from "./IngredientProductionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b404b9a",
  null
  
)

export default component.exports